{
  "name": "pozi2-web",
  "version": "2.4.0",
  "scripts": {
    "preinstall": "node scripts/enforce-npm.js",
    "ng": "ng",
    "start": "ng serve",
    "start:hu": "ng serve --configuration hu",
    "start:ipt": "ng serve --configuration ipt",
    "start:ipt-hu": "ng serve --configuration ipt-hu",
    "start:be-dev": "ng serve --configuration be-dev",
    "start:bc-prod": "ng serve --configuration bc-prod",
    "start:ipt-prod": "ng serve --configuration ipt-prod",
    "build": "ng build",
    "prod-build": "ng build --configuration production",
    "test-build": "ng build --configuration test --source-map=true",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --no-watch",
    "test:watch": "ng test --watch",
    "todo:check": "node scripts/validate-todo.mjs",
    "i18n:check": "node scripts/check-i18n.mjs",
    "tools:test": "node scripts/validate-todo.mjs && node scripts/validate-todo.test.mjs && node scripts/check-i18n.mjs && node scripts/check-i18n.test.mjs && node scripts/format-idempotency.test.mjs && node scripts/gen-api-docs/mock-size-cap.test.js && node scripts/gen-api-docs/determinism.test.js && npm run gen-api-docs:self-test",
    "lint": "ng lint --fix",
    "format:check": "prettier --check .",
    "postinstall": "husky",
    "i18n": "ng extract-i18n",
    "i18n:split:duplicate": "node scripts/split-i18n.js --policy=duplicate",
    "i18n:split:three-file": "node scripts/split-i18n.js --policy=three-file",
    "i18n:merge": "node scripts/merge-i18n.js",
    "gen-api-docs": "node scripts/gen-api-docs/index.js --module=ipt,wmm,admin",
    "gen-api-docs:check": "node scripts/gen-api-docs/index.js --module=ipt,wmm,admin --check --self-test",
    "gen-api-docs:self-test": "node scripts/gen-api-docs/index.js --module=ipt,wmm,admin --self-test-only",
    "publish-api-docs": "node scripts/gen-api-docs/publish-wiki.js --module=ipt,wmm,admin"
  },
  "private": true,
  "packageManager": "npm@11.6.2",
  "engines": {
    "node": "^22.22.3 || ^24.15.0 || >=26.0.0",
    "npm": ">=10"
  },
  "dependencies": {
    "@amcharts/amcharts5": "^5.10.0",
    "@angular/cdk": "~22.0.4",
    "@angular/common": "^22.0.6",
    "@angular/compiler": "^22.0.6",
    "@angular/core": "^22.0.6",
    "@angular/forms": "^22.0.6",
    "@angular/google-maps": "~22.0.4",
    "@angular/material": "~22.0.4",
    "@angular/material-date-fns-adapter": "22.0.4",
    "@angular/platform-browser": "^22.0.6",
    "@angular/router": "^22.0.6",
    "@googlemaps/js-api-loader": "^1.16.2",
    "@pozi/authmodule": "0.0.26",
    "@stomp/rx-stomp": "^2.0.0",
    "@stomp/stompjs": "^7.0.0",
    "angular-oauth2-oidc": "22.0.2",
    "date-fns": "^3.3.1",
    "file-saver": "^2.0.5",
    "inter-ui": "^3.19.3",
    "material-symbols": "^0.36.2",
    "ngx-cookie-service": "^22.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^11.1.1"
  },
  "devDependencies": {
    "@angular/build": "^22.0.6",
    "@angular/cli": "~22.0.6",
    "@angular/compiler-cli": "^22.0.6",
    "@angular/localize": "^22.0.6",
    "@types/file-saver": "^2.0.7",
    "@types/google.maps": "3.64.0",
    "@types/node": "^24.13.3",
    "angular-eslint": "^22.0.0",
    "eslint": "^9.28.0",
    "husky": "^9.0.10",
    "jsdom": "^29.1.1",
    "lint-staged": "^15.2.2",
    "ng-extract-i18n-merge": "3.4.0",
    "prettier": "^3.5.3",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.63.0",
    "vitest": "^4.1.10",
    "yaml": "2.9.0",
    "zod": "4.4.2"
  },
  "overrides": {
    "@babel/core": "7.29.7",
    "esbuild": "0.28.1"
  }
}
